import { getEnvironmentVariable } from "../global/environmentVariables";
import { urlParams } from "./urlParams";

const AUTH_CLIENT_ID = getEnvironmentVariable("AUTH_CLIENT_ID") || "web-app";

const { client_id } = urlParams();
let defaultEndpoint =
  process.env.REACT_APP_API_URL || getEnvironmentVariable("API_URL");
const storedClientId = sessionStorage?.getItem("client_id");

let defaultHeader = {
  "client-id": client_id || storedClientId || AUTH_CLIENT_ID,
};

export async function postData(route = "", data = {}, headers, customUrl) {
  // Finds endpoints and headers
  let endpoint = customUrl || defaultEndpoint;
  let header = headers ? headers : defaultHeader;

  // Converts existing api calls using the { body: {...body} } format to simply {...body}
  if (data?.body) {
    data = { ...data.body };
  }

  // Fetch options, default options are marked with *
  const response = await fetch(`${endpoint}${route}`, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    cache: "default", // *default, no-cache, reload, force-cache, only-if-cached
    credentials: "same-origin", // include, *same-origin, omit
    headers: {
      "Content-Type": "application/json",
      ...defaultHeader,
      ...header,
    },
    redirect: "follow", // manual, *follow, error
    referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    body: JSON.stringify(data), // body data type must match "Content-Type" header
  });
  let json = await response.json();

  // eslint-disable-next-line
  if (response?.status == 200) {
    return json;
  } else {
    let error = new Error(json.error);
    error.name = response.status;
    throw error;
  }
}

export async function getData(route = "", params = {}, headers, customUrl) {
  // Finds endpoints and headers
  let endpoint = customUrl || defaultEndpoint;
  let header = headers ? headers : defaultHeader;

  // TODO: Could be a problem for any "GET" queries that contain a query parameter thats an array (aside from "expand[]"), need to update

  // Converts existing api calls using the { queryStringParameter: {...params} } format to simply {...params}
  if (params?.queryStringParameters) {
    params = { ...params.queryStringParameters };
  }

  // Converts "expand[]" param into usable fetch string - pt 1
  let expandParams = "";
  if (params?.["expand[]"] && Array.isArray(params?.["expand[]"])) {
    expandParams = params["expand[]"];
    delete params["expand[]"];
  }

  // Creates url
  let newUrl = endpoint + route + `?${new URLSearchParams({ ...params })}`;

  // Converts "expand[]" param into usable fetch string - pt 2
  if (expandParams && expandParams !== "") {
    let tempString = expandParams.toString();
    tempString = tempString.replace(/,/g, "&expand%5B%5D=");
    tempString = "&expand%5B%5D=" + tempString;

    newUrl += tempString;
  }

  const finalHeaders = {
    "Content-Type": "application/json",
    ...header,
  };

  const apiData = await fetch(newUrl, {
    method: "GET",
    mode: "cors",
    cache: "default",
    headers: finalHeaders,
  });

  let json = await apiData.json();

  // eslint-disable-next-line
  if (apiData?.status == 200) {
    return json;
  } else {
    let error = new Error(json.error);
    error.name = apiData.status;
    throw error;
  }
}

export async function deleteData(route = "", data = {}, headers) {
  // Finds endpoints and headers
  let endpoint = defaultEndpoint;
  let header = headers ? headers : defaultHeader;

  // Converts existing api calls using the { body: {...body} } format to simply {...body}
  if (data?.body) {
    data = { ...data.body };
  }

  const apiData = await fetch(`${endpoint}${route}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      ...header,
    },
    body: JSON.stringify(data),
  });

  let json = await apiData.json();

  // eslint-disable-next-line
  if (apiData?.status == 200) {
    return json;
  } else {
    let error = new Error(json.error);
    error.name = apiData.status;
    throw error;
  }
}
